/** Name to display for credit */
export const CREDIT_DISPLAY_NAME = "token";

/** Name to display for credits */
export const CREDITS_DISPLAY_NAME = "tokens";

/** Used as key to save token balance in local storage while purchasing new tokens */
export const CREDITS_BALANCE = "creditBalance";

/**
 * Used as key to determine if new credit purchased
 * Set this key in session storage while redirection after purchase
 */
export const HAS_CREDIT_PURCHASED = "hasCreditPurchased";

/**
 * Token packages customers can request a quote for, at 10 tokens per USD.
 */
export const CREDIT_PACKAGES = [{
  id: "small",
  badge: "SMALL",
  name: "Small",
  tokenAmount: 10_000,
  priceInCents: 100_000
}, {
  id: "medium",
  badge: "MEDIUM",
  name: "Medium",
  tokenAmount: 50_000,
  priceInCents: 475_000
}, {
  id: "large",
  badge: "LARGE",
  name: "Large",
  tokenAmount: 100_000,
  priceInCents: 900_000
}];